import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button } from "semantic-ui-react";
import { selectViewingOlderVersion } from "../../slices/viewingOlderVersion/viewingOlderVersionSlice";
import { globalLoadingOff, globalLoadingOn } from "../../slices/globalLoading/globalLoadingSlice";
import { selectResourceById } from "../../slices/resourceCollection/resourceCollectionSlice";
import { selectCurrentUserApiToken, selectSseConnectionId } from "../../slices/currentUser/currentUserSlice";
import updateFhirJson from "../../functions/updateFhirJsonAPI";
import getDisplayTitle from "../resourceDisplayCommonFunctions/getDisplayTitle";
import { fevirPublicationStatusActive } from "../../dictionaries/THOandFHIRValueSets";

const publishAction = async (foi, parentResourceDetail, dispatch, apiToken, connectionId,
    jsonViewEditingState, setJsonViewEditingState, navigate) => {
    dispatch(globalLoadingOn());
    setJsonViewEditingState(prevState => { return { ...prevState, "status": "active" }; });
    let fhirJson;
    if (jsonViewEditingState.fhirEntryStringRevised) {
        fhirJson = JSON.parse(jsonViewEditingState.fhirEntryStringRevised);
    } else {
        fhirJson = JSON.parse(jsonViewEditingState.fhirEntryString);
    }
    if (fhirJson.extension) {
        let publicationExtensionFound = false;
        for (let extension of fhirJson.extension) {
            if (extension.url === "http://hl7.org/fhir/uv/ebm/StructureDefinition/artifact-publication-status") {
                extension.valueCodeableConcept = fevirPublicationStatusActive;
                publicationExtensionFound = true;
            }
        }
        if (!publicationExtensionFound) {
            fhirJson.extension.push({
                "url": "http://hl7.org/fhir/uv/ebm/StructureDefinition/artifact-publication-status",
                "valueCodeableConcept": fevirPublicationStatusActive
            });
        }
    } else {
        fhirJson.extension = [{
            "url": "http://hl7.org/fhir/uv/ebm/StructureDefinition/artifact-publication-status",
            "valueCodeableConcept": fevirPublicationStatusActive
        }]
    }
    let response = await updateFhirJson(foi, fhirJson, getDisplayTitle(fhirJson, parentResourceDetail), apiToken, connectionId);
    dispatch(globalLoadingOff());
    if (response?.success) {
        navigate("/" + foi, { replace: true });
    }
}

const PublishButton = ({ foi, jsonViewEditingState, additionalClassName, setJsonViewEditingState }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const connectionId = useSelector(selectSseConnectionId);
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const viewingOlderVersion = useSelector(state => selectViewingOlderVersion(state));
    let className = "formButton";
    if (additionalClassName) {
        className += " " + additionalClassName;
    }
    return <Button className={className}
        style={{ color: "#000000", width: additionalClassName ? "100%" : "" }}
        content={"Publish"}
        onClick={() => {
            publishAction(foi, parentResourceDetail, dispatch, apiToken, connectionId,
                jsonViewEditingState, setJsonViewEditingState, navigate);
        }}
        disabled={viewingOlderVersion}
    />;
};

export default PublishButton;